import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const driversAdapter = getAdapter();

const driversSlice = createSlice({
  name: 'drivers',
  initialState: driversAdapter.getInitialState(),
  reducers: {
    setDrivers: (state, { payload: { drivers } }) => {
      driversAdapter.setAll(state, drivers);
    },
  },
});

const selectors = driversAdapter.getSelectors(({ drivers }) => drivers);

export const getDrivers = (state) => selectors.selectAll(state);

export const {
  setDrivers,
} = driversSlice.actions;

export default driversSlice.reducer;
